
import React from 'react';
import { HotelForm } from './HotelForm';
import { HotelList } from './HotelList';
import { Button } from '@/components/ui/button';
import { Share2 } from 'lucide-react';
import { useInviteLink } from '@/hooks/travel/useInviteLink';
import { useIsMobile } from '@/hooks/use-mobile';

interface HotelSearchProps {
  tripId: string;
}

const HotelSearch: React.FC<HotelSearchProps> = ({ tripId }) => {
  const isMobile = useIsMobile();
  const { generateShareLink, copyLinkToClipboard, isSharing } = useInviteLink(tripId);
  
  const handleShareTrip = async () => {
    await copyLinkToClipboard();
  };

  return (
    <div className="space-y-6 w-full max-w-full overflow-hidden">
      <div className={`flex ${isMobile ? 'flex-col gap-2' : 'justify-between items-center'}`}>
        <h2 className="text-xl font-semibold">Hotel Accommodations</h2>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleShareTrip}
          className="flex items-center gap-1 whitespace-nowrap"
          disabled={isSharing}
        >
          <Share2 className="h-4 w-4" />
          {isMobile ? "Share" : "Share Trip"}
        </Button>
      </div>
      <div className="w-full max-w-full overflow-x-visible">
        <HotelList tripId={tripId} />
        <HotelForm tripId={tripId} />
      </div>
    </div>
  );
};

export default HotelSearch;
